export const FETCH_API_DATA_SUCCESS = 'FETCH_API_DATA_SUCCESS';
export const SET_LOADING = 'SET_LOADING';

export const fetchApiDataSuccess = (data) => {
  return {
    type: FETCH_API_DATA_SUCCESS,
    payload: data
  };
};

export const setPageLoading = (loading) => {
  return {
    type: SET_LOADING,
    payload: loading,
  }
}